import React, { useState, useContext } from 'react';
import { TextField, Button } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import DragAndDropTarget from '../DragAndDropTarget';

import '../App.css';

const UploadVideo = () => {
  const [file, setFile] = useState(null);
  const [displayName, setDisplayName] = useState('');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleFileUpload = (files) => {
    if (files.length !== 1) {
      setErrorMessage('Please select a single file');
      setOpenErrorDialog(true);
      return;
    }
    const file = files[0];
    if (file.name.endsWith('.mp4')) {
      setFile(file);
      setDisplayName(file.name);
      setDescription(file.name);
    } else {
      setErrorMessage('Only .mp4 files are allowed');
      setOpenErrorDialog(true);
    }
  };
  
  const uploadVideo = async () => {
    if (file === null || displayName === '' || description === '') {
      setErrorMessage('Please fill in all fields');
      setOpenErrorDialog(true);
      return;
    }
    try {
      const params = new FormData();
      params.append(file.name, file);
      const response = await fetch(`/itvs-site/uploadVideo?site=${user._site._id}`, {
        method: "post",
        headers : {
          'Accept': 'application/json'
        },
        body: params,
      });
      const json = await response.json();
      if (json.error) {
        setErrorMessage(user.error.message);
        setOpenErrorDialog(true);
      } else {
        navigate("/events");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(`upload video failed: ${err}`);
      setOpenErrorDialog(true);
    }
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="UploadVideo">
      <DragAndDropTarget onFileUpload={handleFileUpload} 
        message="Drag and drop a .mp4 video file here or click to select it"
      />
      <TextField className="TextField"
        label="Display Name"
        value={displayName}
        disabled={true}
        onChange={(e) => setDisplayName(e.target.value)}
      />
      <TextField className="TextField"
        label="Description"
        value={description}
        disabled={true}
        onChange={(e) => setDescription(e.target.value)}
      />
      <Button className="Button" variant="contained" color="primary" onClick={uploadVideo}>
        Save
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default UploadVideo;